<template>
    <section id="form_section">
        <div class="container">
            <div class="service_header">
                <h1 class="service_title">Конфігуратор ЩО90</h1>
                <a href="javascript:void(0)" v-on:click="modal_info = true" class="info_btn">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="info-icon" d="M9.5 5H11.5V7H9.5V5ZM9.5 9H11.5V15H9.5V9ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z" fill="#356EEF"/>
                    </svg>
                    Опис роботи сервісу
                </a>
            </div>


            <div class="content_container">
                <div class="forms_container">
                    <div class="input_container">
                        <div class="form_input_item">
                            <span class="form_input_title">Номінальний струм шин, А <b>*</b></span>
                            <select class="form_select" :class="{'border-danger': selected_nominal_bus_current_error, 'not_selected': !selected_nominal_bus_current}" @change="addPanel()" v-model="selected_nominal_bus_current">
                                <option :value="null" disabled selected>Оберіть значення</option>
                                <option class="selectable" v-for="(nominal_bus_current, i) in nominal_bus_currents" :key="`value_${i}`" :value="nominal_bus_current">{{ nominal_bus_current }}</option>
                            </select>
                        </div>
                        <div class="form_input_item">
                            <span class="form_input_title">Матеріал шин <b>*</b></span>
                            <select class="form_select" :class="{'border-danger': selected_bus_material_error, 'not_selected': !selected_bus_material}" @change="addPanel('selected_bus_material')" v-model="selected_bus_material">
                                <option :value="null" disabled selected>Оберіть значення</option>
                                <option class="selectable" v-for="(bus_material, i) in bus_materials" :key="`value_${i}`" :value="bus_material">{{ bus_material }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="input_container">
                        <div class="form_input_item">
                            <span class="form_input_title">Кількість панелей <b>*</b></span>
                            <select class="form_select" :class="{'border-danger': panel_count_error, 'not_selected': !panel_count}" v-model="panel_count" @change="addPanel()">
                                <option :value="null" disabled selected>Оберіть значення</option>
                                <option class="selectable" v-for="(num, i) in 10" :key="`value_${i}`" :value="num">{{ num }}</option>
                            </select>
                        </div>
                        <div class="form_input_item">
                            <span class="form_input_title">Глибина панелей, мм <b>*</b></span>
                            <select class="form_select" :class="{'border-danger': selected_panel_depth_error, 'not_selected': !selected_panel_depth}" @change="addPanel('selected_panel_depth')" v-model="selected_panel_depth">
                                <option :value="null" disabled selected>Оберіть значення</option>
                                 <option class="selectable" v-for="(panel_depth, i) in panel_depths" :key="`value_${i}`" :value="panel_depth">{{ panel_depth }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="input_container">
                        <div class="form_input_item">
                            <span class="form_input_title">Виконання панелей <b>*</b></span>
                            <select class="form_select" :class="{'border-danger': selected_panel_implementation_error, 'not_selected': !selected_panel_implementation}" @change="addPanel('selected_panel_implementation')" v-model="selected_panel_implementation">
                                <option :value="null" disabled selected>Оберіть значення</option>
                                 <option class="selectable" v-for="(panel_implementation, i) in panel_implementations" :key="`value_${i}`" :value="panel_implementation">{{ panel_implementation }}</option>
                            </select>
                        </div>
                        <div class="form_input_item">
                            <span class="form_input_title">Цоколь, мм <b>*</b></span>
                            <select class="form_select" v-model="selected_socle" @change="addPanel('selected_socle')">
                                <option class="selectable" :value="null">Ні</option>
                                <option class="selectable" v-for="(socle, i) in socles" :key="`value_${i}`" :value="socle">{{ socle }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="slider_container">
                    <div class="slider">
                        <div class="slider_main">
                            <div class="slider_prev" @click="sliderPrew()">
                                <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.91003 1.91L3.33003 6.5L7.91003 11.09L6.50003 12.5L0.500034 6.5L6.50003 0.5L7.91003 1.91Z" fill="#356EEF"/>
                                </svg>
                            </div>
                            <img :src="images[sliderIndex]" />
                           <div class="slider_next" @click="sliderNext()">
                                <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.0899658 1.91L4.66997 6.5L0.0899658 11.09L1.49997 12.5L7.49997 6.5L1.49997 0.5L0.0899658 1.91Z" fill="#356EEF"/>
                                </svg>
                            </div>
                        </div>
                        <div class="slider_indicators" ref="wrapper">
                            <img v-for="(image, i) in images" :key="`value_${i}`" @click="sliderIndex=i" class="slider_preview_img" :class="{active: sliderIndex===i}" :src="image" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="main_table_container" :class="{loading: loading}">
                <table class="main_table">
                    <tr>
                        <th class="main_table_title">№ панелі</th>
                        <th class="main_table_title">Тип панелі</th>
                        <th class="main_table_title">Ширина панелі, мм</th>
                        <th class="main_table_title">Струм авт. вим, А</th>
                        <th class="main_table_title">Виконання ввідного та секційного автомата</th>
                        <th class="main_table_title">К-сть роз`єднувачів які відходять, шт.</th>
                        <th class="main_table_title">Струм роз'єднувача, А</th>
                        <th class="main_table_title">Струм запобіжника, А</th>
                        <th class="main_table_title">Вимірювання, АВР (секційна панель)</th>
                        <th class="main_table_title">Комерційний облік</th>
                    </tr>
                    <tr v-if="!panels.length">
                        <td class="main_table_row" style="text-align: center;"></td>
                        <td class="main_table_row" style="text-align: center;"></td>
                        <td class="main_table_row" style="text-align: center;"></td>
                        <td class="main_table_row" style="text-align: center;"></td>
                        <td class="main_table_row" style="text-align: center;"></td>
                        <td class="main_table_row" style="text-align: center;"></td>
                        <td class="main_table_row" style="text-align: center;"></td>
                        <td class="main_table_row" style="text-align: center;"></td>
                        <td class="main_table_row" style="text-align: center;"></td>
                        <td class="main_table_row" style="text-align: center;"></td>
                    </tr>
                    <tr v-for="(num, i) in panels.length" :key="i" :class="getClass(panels[i].panel_type)">
                        <td class="main_table_row" style="text-align: center;">
                            <span class="table_num">{{ num }}</span>
                        </td>
                        <td class="main_table_row" style="text-align: center;">
                            <template v-if="panels[i] && i === 0">
                                <select class="form_select table_select" :class="{not_selected: !panels[i].panel_type, 'border-danger': panelsValidation[i] && panelsValidation[i].includes('panel_type')}" v-if="panels[i]" v-model="panels[i].panel_type" @change="getNextStep(i, 'panel_widths', panels[i])">
                                    <option :value="null" disabled>Обрати</option>
                                    <option class="selectable" v-for="(panel_type, key) in panels[i].panel_types" :key="`value_${key}`" :value="panel_type" :disabled="num===1 && panel_type==='Секційна'">{{ panel_type }}</option>
                                </select>
                            </template>
                            <select class="form_select table_select" :class="{not_selected: !panels[i].panel_type, 'border-danger': panelsValidation[i] && panelsValidation[i].includes('panel_type')}" v-else-if="panels[i-1] && panels[i-1].panel_type" v-model="panels[i].panel_type" @change="getNextStep(i, 'panel_widths', panels[i])">
                                <option :value="null" disabled>Обрати</option>
                                <option class="selectable" v-for="(panel_type, key) in panels[i].panel_types" :key="`value_${key}`" :value="panel_type" :disabled="num===1 && panel_type==='Секційна'">{{ panel_type }}</option>
                            </select>
                        </td>
                        <td class="main_table_row" style="text-align: center;">
                            <select class="form_select table_select" :class="{not_selected: !panels[i].panel_width, 'border-danger': panelsValidation[i] && panelsValidation[i].includes('panel_width')}" v-if="panels[i] && panels[i].panel_type" v-model="panels[i].panel_width" @change="getNextStep(i, panels[i] && panels[i].panel_type === 'Лінійна' ? 'disconnector_currents' : 'auto_switcher_currents', panels[i])">
                                <option :value="null" disabled>Обрати</option>
                                <option class="selectable" v-for="(panel_width, key) in panels[i].panel_widths" :key="`value_${key}`" :value="panel_width">{{ panel_width }}</option>
                            </select>
                        </td>
                        <td class="main_table_row" style="text-align: center;">
                            <select class="form_select table_select" :class="{not_selected: !panels[i].auto_switcher_current, 'border-danger': panelsValidation[i] && panelsValidation[i].includes('auto_switcher_current')}" v-if="panels[i] && panels[i].panel_width && panels[i].panel_type !== 'Лінійна'" v-model="panels[i].auto_switcher_current" @change="getNextStep(i, 'auto_implementations', panels[i])">
                                <option :value="null" disabled>Обрати</option>
                                <option class="selectable" v-for="(auto_switcher_current, key) in panels[i].auto_switcher_currents" :key="`value_${key}`" :value="auto_switcher_current">{{ auto_switcher_current }}</option>
                            </select>
                        </td>
                        <td class="main_table_row svg_right" :class="{border_line: panels[i] && panels[i].panel_type && panels[i].panel_type !== 'Секційна'}" style="text-align: center;">
                            <select class="form_select table_select" :class="{not_selected: !panels[i].auto_implementation, 'border-danger': panelsValidation[i] && panelsValidation[i].includes('auto_implementation')}" v-if="panels[i] && panels[i].auto_switcher_current && panels[i].panel_type !== 'Лінійна'" v-model="panels[i].auto_implementation" @change="getNextStep(i, panels[i] && panels[i].panel_type === 'Лінійна' ? 'disconnector_currents' : 'avr_panels', panels[i])">
                                <option :value="null" disabled>Обрати</option>
                                <option class="selectable" v-for="(auto_implementation, key) in panels[i].auto_implementations" :key="`value_${key}`" :value="auto_implementation">{{ auto_implementation }}</option>
                            </select>
                            <template v-else-if="panels[i] && panels[i].panel_width && panels[i].panel_type === 'Лінійна'">
                                <div class="svg_lines">
                                    <div v-for="(val, k) in panels[i].disconnector_count" :key="`value11_${k}`">
                                        <svg width="92" height="40" viewBox="0 0 92 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.7492 35.5675C19.5104 35.7061 19.4292 36.0121 19.5678 36.2509C19.7064 36.4897 20.0124 36.5709 20.2512 36.4323L19.7492 35.5675ZM80.3272 1.55747L80.7596 1.30645L80.2576 0.441608L79.8252 0.692632L80.3272 1.55747ZM20.2512 36.4323L80.3272 1.55747L79.8252 0.692632L19.7492 35.5675L20.2512 36.4323Z" fill="black"/>
                                            <rect x="27.683" y="22.1708" width="42.9758" height="16.4255" transform="rotate(-30 27.683 22.1708)" stroke="black"/>
                                            <path d="M20 36.5C20.2761 36.5 20.5 36.2761 20.5 36C20.5 35.7239 20.2761 35.5 20 35.5V36.5ZM4 36.5H20V35.5H4V36.5Z" fill="black"/>
                                            <rect y="36" width="5" height="5" transform="rotate(-45 0 36)" fill="black"/>
                                            <path d="M88 35.5356H72" stroke="black"/>
                                            <rect width="5" height="5" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 92 35.5356)" fill="black"/>
                                        </svg>
                                    </div>
                                </div>
                            </template>
                        </td>
                        <td class="main_table_row svg_left" style="text-align: center;">
                            <select class="form_select table_select" :class="{not_selected: !panels[i].disconnector_count}" v-model="panels[i].disconnector_count" v-if="panels[i] && panels[i].panel_type === 'Лінійна'" @change="changeMultipart(i)">
                                <option :value="null" disabled selected>Оберіть значення</option>
                                <option class="selectable" v-for="(num, key) in panels[i].panel_width === 600 ? 4 : 6" :key="`value_${key}`" :value="num">{{ num }}</option>
                            </select>
                            <svg v-else-if="panels[i] && panels[i].panel_type && panels[i].panel_type === 'Ввідна'" width="71" height="22" viewBox="0 0 71 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 17.5356H22" stroke="black"/>
                                <rect y="17.5356" width="5" height="5" transform="rotate(-45 0 17.5356)" fill="black"/>
                                <path d="M21.5 2.5L47 17.5H66.5" stroke="black"/>
                                <rect x="63" y="17.5356" width="5" height="5" transform="rotate(-45 63 17.5356)" fill="black"/>
                                <mask id="path-5-inside-1_696_7386" fill="white">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M43.2852 5.07213L34.5 0L30 7.79423L30.8721 8.29776L34.8828 1.35107L41.9149 5.41102L37.9042 12.3577L38.7852 12.8664L43.2852 5.07213Z"/>
                                </mask>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M43.2852 5.07213L34.5 0L30 7.79423L30.8721 8.29776L34.8828 1.35107L41.9149 5.41102L37.9042 12.3577L38.7852 12.8664L43.2852 5.07213Z" fill="black"/>
                                <path d="M34.5 0L35 -0.866025L34.134 -1.36603L33.634 -0.5L34.5 0ZM43.2852 5.07213L44.1512 5.57213L44.6512 4.70611L43.7852 4.20611L43.2852 5.07213ZM30 7.79423L29.134 7.29423L28.634 8.16025L29.5 8.66025L30 7.79423ZM30.8721 8.29776L30.3721 9.16379L31.2382 9.66379L31.7382 8.79776L30.8721 8.29776ZM34.8828 1.35107L35.3828 0.485049L34.5168 -0.0149512L34.0168 0.851074L34.8828 1.35107ZM41.9149 5.41102L42.7809 5.91102L43.2809 5.045L42.4149 4.545L41.9149 5.41102ZM37.9042 12.3577L37.0382 11.8577L36.5382 12.7237L37.4042 13.2237L37.9042 12.3577ZM38.7852 12.8664L38.2852 13.7324L39.1512 14.2324L39.6512 13.3664L38.7852 12.8664ZM34 0.866025L42.7852 5.93816L43.7852 4.20611L35 -0.866025L34 0.866025ZM30.866 8.29423L35.366 0.5L33.634 -0.5L29.134 7.29423L30.866 8.29423ZM31.3721 7.43173L30.5 6.9282L29.5 8.66025L30.3721 9.16379L31.3721 7.43173ZM31.7382 8.79776L35.7488 1.85107L34.0168 0.851074L30.0061 7.79776L31.7382 8.79776ZM34.3828 2.2171L41.4149 6.27705L42.4149 4.545L35.3828 0.485049L34.3828 2.2171ZM41.0488 4.91102L37.0382 11.8577L38.7702 12.8577L42.7809 5.91102L41.0488 4.91102ZM39.2852 12.0003L38.4042 11.4917L37.4042 13.2237L38.2852 13.7324L39.2852 12.0003ZM42.4192 4.57213L37.9192 12.3664L39.6512 13.3664L44.1512 5.57213L42.4192 4.57213Z" fill="black" mask="url(#path-5-inside-1_696_7386)"/>
                            </svg>
                            <svg v-else-if="panels[i] && panels[i].panel_type && panels[i].panel_type === 'Секційна'" width="67" height="55" viewBox="0 0 67 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 46.5356H22" stroke="black"/>
                                <rect y="46.5356" width="5" height="5" transform="rotate(-45 0 46.5356)" fill="black"/>
                                <rect y="7.53564" width="5" height="5" transform="rotate(-45 0 7.53564)" fill="black"/>
                                <path d="M21.5 31.5L47 46.5H66.5V8H3" stroke="black"/>
                                <mask id="path-5-inside-1_697_7402" fill="white">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M43.2852 34.0721L34.5 29L30 36.7942L30.8721 37.2978L34.8828 30.3511L41.9149 34.411L37.9042 41.3577L38.7852 41.8664L43.2852 34.0721Z"/>
                                </mask>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M43.2852 34.0721L34.5 29L30 36.7942L30.8721 37.2978L34.8828 30.3511L41.9149 34.411L37.9042 41.3577L38.7852 41.8664L43.2852 34.0721Z" fill="black"/>
                                <path d="M34.5 29L35 28.134L34.134 27.634L33.634 28.5L34.5 29ZM43.2852 34.0721L44.1512 34.5721L44.6512 33.7061L43.7852 33.2061L43.2852 34.0721ZM30 36.7942L29.134 36.2942L28.634 37.1603L29.5 37.6603L30 36.7942ZM30.8721 37.2978L30.3721 38.1638L31.2382 38.6638L31.7382 37.7978L30.8721 37.2978ZM34.8828 30.3511L35.3828 29.485L34.5168 28.985L34.0168 29.8511L34.8828 30.3511ZM41.9149 34.411L42.7809 34.911L43.2809 34.045L42.4149 33.545L41.9149 34.411ZM37.9042 41.3577L37.0382 40.8577L36.5382 41.7237L37.4042 42.2237L37.9042 41.3577ZM38.7852 41.8664L38.2852 42.7324L39.1512 43.2324L39.6512 42.3664L38.7852 41.8664ZM34 29.866L42.7852 34.9382L43.7852 33.2061L35 28.134L34 29.866ZM30.866 37.2942L35.366 29.5L33.634 28.5L29.134 36.2942L30.866 37.2942ZM31.3721 36.4317L30.5 35.9282L29.5 37.6603L30.3721 38.1638L31.3721 36.4317ZM31.7382 37.7978L35.7488 30.8511L34.0168 29.8511L30.0061 36.7978L31.7382 37.7978ZM34.3828 31.2171L41.4149 35.277L42.4149 33.545L35.3828 29.485L34.3828 31.2171ZM41.0488 33.911L37.0382 40.8577L38.7702 41.8577L42.7809 34.911L41.0488 33.911ZM39.2852 41.0003L38.4042 40.4917L37.4042 42.2237L38.2852 42.7324L39.2852 41.0003ZM42.4192 33.5721L37.9192 41.3664L39.6512 42.3664L44.1512 34.5721L42.4192 33.5721Z" fill="black" mask="url(#path-5-inside-1_697_7402)"/>
                                <rect y="7.53564" width="5" height="5" transform="rotate(-45 0 7.53564)" fill="black"/>
                                <path d="M3.5 0V8" stroke="black"/>
                                <rect width="5" height="5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 0 46.5356)" fill="black"/>
                                <path d="M3.49219 54.0713L3.50652 46.0713" stroke="black"/>
                            </svg>
                        </td>
                        <td class="main_table_row" style="text-align: center;">
                            <template v-if="panels[i] && panels[i].panel_width && panels[i].panel_type === 'Лінійна'">
                                <select class="form_select table_select border-bottom" v-for="(val, k) in panels[i].disconnector_count" :key="`value11_${k}`" :class="{not_selected: !panels[i].multipart[k].disconnector_current, 'border-danger': panelsValidation[i] && panelsValidation[i].includes('disconnector_current_'+k)}" v-model="panels[i].multipart[k].disconnector_current" @change="getNextStep(i, 'fuse_currents', panels[i], k)">
                                    <option :value="null" disabled>Обрати</option>
                                    <option class="selectable" v-for="(disconnector_current, key) in panels[i].disconnector_currents" :key="`value_${key}`" :value="disconnector_current">{{ disconnector_current }}</option>
                                </select>
                            </template>
                        </td>
                        <td class="main_table_row" style="text-align: center;">
                            <template v-if="panels[i] && panels[i].panel_width && panels[i].panel_type === 'Лінійна'">
                                <select class="form_select table_select border-bottom" v-for="(val, k) in panels[i].disconnector_count" :key="`value1_${k}`" :class="{not_selected: !panels[i].multipart[k].fuse_current, 'border-danger': panelsValidation[i] && panelsValidation[i].includes('fuse_current_'+k)}" v-model="panels[i].multipart[k].fuse_current" @change="getNextStep(i, 'avr_panels', panels[i], k)">
                                    <option :value="null" disabled>Обрати</option>
                                    <option class="selectable" v-for="(fuse_current, key) in panels[i].multipart[k].fuse_currents" :key="`value_${key}`" :value="fuse_current" :disabled="fuse_current > panels[i].multipart[k].disconnector_current">{{ fuse_current }}</option>
                                </select>
                            </template>
                        </td>
                        <td class="main_table_row" style="text-align: center;">
                            <template v-if="panels[i] && panels[i].panel_width && panels[i].panel_type === 'Лінійна'">
                                <select class="form_select table_select border-bottom" v-for="(val, k) in panels[i].disconnector_count" :key="`value2_${k}`" v-model="panels[i].multipart[k].avr_panel" @change="getNextStep(i, 'commercial_accountings', panels[i], k)">
                                    <option :value="null">Ні</option>
                                    <option class="selectable" v-for="(avr_panel, key) in panels[i].multipart[k].avr_panels" :key="`value_${key}`" :value="avr_panel">{{ avr_panel }}</option>
                                </select>
                            </template>
                            <template v-else>
                                <select class="form_select table_select" :class="{not_selected: !panels[i].avr_panel, 'border-danger': panelsValidation[i] && panelsValidation[i].includes('avr_panel')}" v-if="(panels[i] && panels[i].fuse_current && panels[i].panel_type === 'Лінійна') || (panels[i] && panels[i].auto_implementation && panels[i].panel_type !== 'Лінійна')" v-model="panels[i].avr_panel" @change="getNextStep(i, 'commercial_accountings', panels[i])">
                                    <option :value="null">Обрати</option>
                                    <option class="selectable" v-for="(avr_panel, key) in panels[i].avr_panels" :key="`value_${key}`" :value="avr_panel">{{ avr_panel }}</option>
                                </select>
                            </template>
                        </td>
                        <td class="main_table_row" style="text-align: center;">
                            <template v-if="panels[i] && panels[i].panel_width && panels[i].panel_type === 'Лінійна'">
                                <select class="form_select table_select border-bottom" v-for="(val, k) in panels[i].disconnector_count" :key="`value3_${k}`" v-model="panels[i].multipart[k].commercial_accounting" @change="getNextStep(i, '', panels[i], k)">
                                    <option :value="null">Ні</option>
                                    <option class="selectable" v-for="(commercial_accounting, key) in panels[i].multipart[k].commercial_accountings" :key="`value_${key}`" :value="commercial_accounting">{{ commercial_accounting }}</option>
                                </select>
                            </template>
                            <template v-else-if="panels[i] && panels[i].panel_type !== 'Секційна'">
                                <select class="form_select table_select" v-if="(panels[i] && panels[i].fuse_current && panels[i].panel_type === 'Лінійна') || (panels[i] && panels[i].auto_implementation && panels[i].panel_type !== 'Лінійна')" v-model="panels[i].commercial_accounting" @change="getNextStep(i, '', panels[i])">
                                    <option :value="null">Ні</option>
                                    <option :value="'Так'">Так</option>
                                </select>
                            </template>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="mobile_table" v-if="panels.length">
                <div v-for="(panel, i) in panels" :key="`panel_${i}`" class="dropdown_item">
                    <div class="dropdown_item_title" @click="openPanel(i+1)">
                        <span>Панель №{{i+1}}</span>
                        <svg :class="{active: openedPanel.includes(i+1)}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.41 0.589844L6 5.16984L10.59 0.589844L12 1.99984L6 7.99984L0 1.99984L1.41 0.589844Z" fill="#356EEF"/>
                        </svg>
                    </div>

                    <div class="dropdown_item_content" v-if="openedPanel.includes(i+1)">
                        <div class="dropdown_item_content_container">
                            <p class="dropdown_item_content_title">Тип панелі</p>
                            <template v-if="panels[i] && i === 0">
                                <select class="form_select" :class="{'border-danger': panelsValidation[i] && panelsValidation[i].includes('panel_type')}" v-if="panels[i]" v-model="panels[i].panel_type" @change="getNextStep(i, 'panel_widths', panels[i])">
                                    <option :value="null" disabled>Обрати</option>
                                    <option class="selectable" v-for="(panel_type, key) in panels[i].panel_types" :key="`value_${key}`" :value="panel_type" :disabled="i===0 && panel_type==='Секційна'">{{ panel_type }}</option>
                                </select>
                            </template>
                            <select class="form_select" v-else-if="panels[i-1] && panels[i-1].panel_type" v-model="panels[i].panel_type" :class="{'border-danger': panelsValidation[i] && panelsValidation[i].includes('panel_type')}" @change="getNextStep(i, 'panel_widths', panels[i])">
                                <option :value="null" disabled>Обрати</option>
                                <option class="selectable" v-for="(panel_type, key) in panels[i].panel_types" :key="`value_${key}`" :value="panel_type" :disabled="i===0 && panel_type==='Секційна'">{{ panel_type }}</option>
                            </select>
                        </div>
                        <div class="dropdown_item_content_container">
                            <p class="dropdown_item_content_title">Ширина панелі, мм</p>
                            <select class="form_select" v-if="panels[i] && panels[i].panel_type" :class="{'border-danger': panelsValidation[i] && panelsValidation[i].includes('panel_width')}" v-model="panels[i].panel_width" @change="getNextStep(i, panels[i] && panels[i].panel_type === 'Лінійна' ? 'disconnector_currents' : 'auto_switcher_currents', panels[i])">
                                <option :value="null" disabled>Обрати</option>
                                <option class="selectable" v-for="(panel_width, key) in panels[i].panel_widths" :key="`value_${key}`" :value="panel_width">{{ panel_width }}</option>
                            </select>
                        </div>
                        <div class="dropdown_item_content_container">
                            <p class="dropdown_item_content_title">Струм авт. вим, А</p>
                            <select class="form_select" v-if="panels[i] && panels[i].panel_width && panels[i].panel_type !== 'Лінійна'" :class="{'border-danger': panelsValidation[i] && panelsValidation[i].includes('auto_switcher_current')}" v-model="panels[i].auto_switcher_current" @change="getNextStep(i, 'auto_implementations', panels[i])">
                                <option :value="null" disabled>Обрати</option>
                                <option class="selectable" v-for="(auto_switcher_current, key) in panels[i].auto_switcher_currents" :key="`value_${key}`" :value="auto_switcher_current">{{ auto_switcher_current }}</option>
                            </select>
                            <p v-else>-</p>
                        </div>
                        <div class="dropdown_item_content_container">
                            <p class="dropdown_item_content_title">Виконання ввідного та секційного автомата</p>
                            <select class="form_select" v-if="panels[i] && panels[i].auto_switcher_current && panels[i].panel_type !== 'Лінійна'" :class="{'border-danger': panelsValidation[i] && panelsValidation[i].includes('auto_implementation')}" v-model="panels[i].auto_implementation" @change="getNextStep(i, panels[i] && panels[i].panel_type === 'Лінійна' ? 'disconnector_currents' : 'avr_panels', panels[i])">
                                <option :value="null" disabled>Обрати</option>
                                <option class="selectable" v-for="(auto_implementation, key) in panels[i].auto_implementations" :key="`value_${key}`" :value="auto_implementation">{{ auto_implementation }}</option>
                            </select>
                            <p v-else>-</p>
                        </div>
                        <div class="dropdown_item_content_container">
                            <p class="dropdown_item_content_title">К-сть роз`єднувачів які відходять, шт.</p>
                            <select class="form_select" v-model="panels[i].disconnector_count" v-if="panels[i] && panels[i].panel_type === 'Лінійна'" @change="changeMultipart(i)">
                                <option :value="null" disabled selected>Оберіть значення</option>
                                <option class="selectable" v-for="(num, key) in panels[i].panel_width === 600 ? 4 : 6" :key="`value_${key}`" :value="num">{{ num }}</option>
                            </select>
                            <p v-else>-</p>
                        </div>

                        <template v-if="panels[i] && panels[i].panel_width && panels[i].panel_type === 'Лінійна'">
                            <div v-for="(val, k) in panels[i].disconnector_count" :key="`value11_${k}`" class="dropdown_item">
                                <div class="dropdown_item_title2" @click="openPanel(i+1, k+1)">
                                    <span>Роз`єднувач №{{k+1}}</span>
                                    <svg :class="{active: openedPanel.includes((i+1)+'_'+(k+1))}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.41 0.589844L6 5.16984L10.59 0.589844L12 1.99984L6 7.99984L0 1.99984L1.41 0.589844Z" fill="#356EEF"/>
                                    </svg>
                                </div>

                                <div class="dropdown_item_content" v-if="openedPanel.includes((i+1)+'_'+(k+1))">
                                    <div class="dropdown_item_content_container">
                                        <p class="dropdown_item_content_title">Струм роз'єднувача, А</p>
                                        <select class="form_select" v-model="panels[i].multipart[k].disconnector_current" :class="{'border-danger': panelsValidation[i] && panelsValidation[i].includes('disconnector_current_'+k)}" @change="getNextStep(i, 'fuse_currents', panels[i], k)">
                                            <option :value="null" disabled>Обрати</option>
                                            <option class="selectable" v-for="(disconnector_current, key) in panels[i].disconnector_currents" :key="`value_${key}`" :value="disconnector_current">{{ disconnector_current }}</option>
                                        </select>
                                    </div>
                                    <div class="dropdown_item_content_container">
                                        <p class="dropdown_item_content_title">Струм запобіжника, А</p>
                                        <select class="form_select" v-model="panels[i].multipart[k].fuse_current" :class="{'border-danger': panelsValidation[i] && panelsValidation[i].includes('fuse_current_'+k)}" @change="getNextStep(i, 'avr_panels', panels[i], k)">
                                            <option :value="null" disabled>Обрати</option>
                                            <option class="selectable" v-for="(fuse_current, key) in panels[i].multipart[k].fuse_currents" :key="`value_${key}`" :value="fuse_current" :disabled="fuse_current > panels[i].multipart[k].disconnector_current">{{ fuse_current }}</option>
                                        </select>
                                    </div>
                                    <div class="dropdown_item_content_container">
                                        <p class="dropdown_item_content_title">Вимірювання, АВР (секційна панель)</p>
                                        <select class="form_select" v-model="panels[i].multipart[k].avr_panel" @change="getNextStep(i, 'commercial_accountings', panels[i], k)">
                                            <option :value="null">Ні</option>
                                            <option class="selectable" v-for="(avr_panel, key) in panels[i].multipart[k].avr_panels" :key="`value_${key}`" :value="avr_panel">{{ avr_panel }}</option>
                                        </select>
                                    </div>
                                    <div class="dropdown_item_content_container">
                                        <p class="dropdown_item_content_title">Комерційний облік</p>
                                        <select class="form_select" v-model="panels[i].multipart[k].commercial_accounting" @change="getNextStep(i, '', panels[i], k)">
                                            <option :value="null">Ні</option>
                                            <option class="selectable" v-for="(commercial_accounting, key) in panels[i].multipart[k].commercial_accountings" :key="`value_${key}`" :value="commercial_accounting">{{ commercial_accounting }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="dropdown_item_content_container">
                                <p class="dropdown_item_content_title">Вимірювання, АВР (секційна панель)</p>
                                <select class="form_select" v-if="(panels[i] && panels[i].fuse_current && panels[i].panel_type === 'Лінійна') || (panels[i] && panels[i].auto_implementation && panels[i].panel_type !== 'Лінійна')" :class="{'border-danger': panelsValidation[i] && panelsValidation[i].includes('avr_panel')}" v-model="panels[i].avr_panel" @change="getNextStep(i, 'commercial_accountings', panels[i])">
                                    <option :value="null">Обрати</option>
                                    <option class="selectable" v-for="(avr_panel, key) in panels[i].avr_panels" :key="`value_${key}`" :value="avr_panel">{{ avr_panel }}</option>
                                </select>
                            </div>
                            <div class="dropdown_item_content_container" v-if="panels[i] && panels[i].panel_type !== 'Секційна'">
                                <p class="dropdown_item_content_title">Комерційний облік</p>
                                <select class="form_select" v-if="(panels[i] && panels[i].fuse_current && panels[i].panel_type === 'Лінійна') || (panels[i] && panels[i].auto_implementation && panels[i].panel_type !== 'Лінійна' && panels[i].panel_type !== 'Секційна')" v-model="panels[i].commercial_accounting" @change="getNextStep(i, '', panels[i])">
                                    <option class="selectable" :value="null">Ні</option>
                                    <option class="selectable" :value="'Так'">Так</option>
                                </select>
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <div class="bottom_row">
                <div class="bottom_row_block">
                    <a href="javascript:void(0)" v-if="Object.keys(specItems).length && validatePanelsDocModal()" v-on:click="openDocsModal()" class="btn-download">
                        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path id="download-icon" d="M14 6.5H10V0.5H4V6.5H0L7 13.5L14 6.5ZM0 15.5V17.5H14V15.5H0Z" fill="#356EEF"/>
                        </svg>
                        Документація та ПЗ
                    </a>
                    <a href="javascript:void(0)" v-else class="btn-download" :class="{disabled: !Object.keys(specItems).length || !validatePanelsDocModal()}">
                        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path id="download-icon" d="M14 6.5H10V0.5H4V6.5H0L7 13.5L14 6.5ZM0 15.5V17.5H14V15.5H0Z" fill="#356EEF"/>
                        </svg>
                        Документація та ПЗ
                    </a>
                </div>
                <div class="total_btns" v-if="Object.keys(specItems).length">
                    <a class="view_spec_btn" v-on:click="showSpec()">Переглянути специфікацію</a>
                    <a class="download_spec" v-on:click="getExcel()">Завантажити специфікацію в Excel</a>
                </div>
                <div class="total_btns" v-else>
                    <a class="view_spec_btn" :class="{disabled: !Object.keys(specItems).length}">Переглянути специфікацію</a>
                    <a class="download_spec" :class="{disabled: !Object.keys(specItems).length}">Завантажити специфікацію в Excel</a>
                </div>
            </div>

        </div>

        <div class="overlay" v-if="modal_info || modal_docs || modal_total" v-on:click="() => {modal_info=false; modal_docs=false; modal_total=false;}"></div>
        
        <div class="modal description_modal" v-if="modal_info">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Опис роботи сервісу</p>
                    <svg id="close_modal" v-on:click="modal_info = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content" v-html="text"></div>
            </div>
        </div>
        <div class="modal docs_modal" v-if="modal_docs">
            <div class="modal_container">
                <div class="modal_header">
                    <div class="nosense"></div>
                    <p class="modal_header_title">Документація та ПЗ</p>
                    <svg id="close_modal" v-on:click="modal_docs = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content">
                    <ul class="filelist">
                        <template v-for="(docs, section) in files">
                        <li class="cat_name" :key="`file_${section}`" v-if="section"><span>{{ section }}</span></li>
                        <li v-for="(file, i) in docs" :key="`file_${i}`" class="filelist_item">
                            <a :href="file.file" target="_blank" class="file_item">
                                <svg style="margin-top: 5px;" width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.5 0C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0H2.5ZM9.5 7V1.5L15 7H9.5Z" fill="#356EEF"/>
                                </svg>

                                <div class="file_item_container">
                                    <span class="file_name">{{ file.file_name }} ({{ file.file_size }})</span>
                                </div>
                                <div class="download_ico">
                                    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z" fill="#356EEF"/>
                                    </svg>
                                </div>
                            </a>
                        </li>
                        </template>
                        <li class="cat_name" v-if="file && issetSectionPanel()"><span>ПЗ</span></li>
                        <li class="filelist_item" v-if="file && issetSectionPanel()">
                            <a :href="file.file" target="_blank" class="file_item">
                                <svg style="margin-top: 5px;" width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.5 0C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0H2.5ZM9.5 7V1.5L15 7H9.5Z" fill="#356EEF"/>
                                </svg>

                                <div class="file_item_container">
                                    <span class="file_name">{{ file.file_name }} ({{ file.file_size }})</span>
                                </div>
                                <div class="download_ico">
                                    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z" fill="#356EEF"/>
                                    </svg>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="modal modal_total" v-if="modal_total">
            <div class="modal_header">
                <p class="modal_header_title">Специфікація</p>
                <svg id="close_modal" v-on:click="() => {modal_total = false; summarize = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                </svg>
            </div>
            <div class="modal_content">
                <br>
                <br>

                <template v-if="!summarize">
                    <template v-for="(types, i) in specItems" :key="`itemi_${i}`">
                        <p class="title" v-if="checkKey(i)">Панель {{ i }}</p>
                        <p class="title" v-else>{{ i }}</p>
                                <table style="width:100%; z-index:1;border-collapse: collapse;" class="spec_table" border=1>
                                    <thead>
                                        <th class="total_key summ_text">#</th>
                                        <th class="total_title summ_text">Найменування</th>
                                        <th class="total_maker summ_text">Виробник</th>
                                        <th class="total_count summ_text">Кількість</th>
                                        <th class="total_od summ_text">Од. Вим.</th>
                                        <th class="total_price center summ_text">Ціна, грн. без ПДВ</th>
                                        <th class="total_summ2 center summ_text">Сума, грн. без ПДВ</th>
                                        <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                                    </thead>
                                    <tbody>
                                        <template v-for="(products, name) in types" :key="`itemi_${name}`">
                                            <tr>
                                                <td class="total_key"></td>
                                                <td class="total_title"><p class="title">{{ name }}</p></td>
                                                <td class="total_maker"></td>
                                                <td class="total_count"></td>
                                                <td class="total_od"></td>
                                                <td class="total_price"></td>
                                                <td class="total_summ2"></td>
                                                <td class="total_tech"></td>
                                            </tr>
                                            <tr v-for="(item, i) in products" :key="`item_${i}`">
                                                <td class="total_key">{{ i+1 }}</td>
                                                <td class="total_title">{{ item.description }}</td>
                                                <td class="total_maker">{{ item.maker }}</td>
                                                <td class="total_count">{{ item.count }}</td>
                                                <td class="total_od">шт.</td>
                                                <td class="total_price">{{ numberWithSpaces(item.price_nds/1.2) }}</td>
                                                <td class="total_summ2">{{ numberWithSpaces((item.price_nds/1.2) * item.count) }}</td>
                                                <td class="total_tech">
                                                    <a :href="item.tech_char" target="_blank">
                                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                                        </svg>
                                                    </a>
                                                </td>
                                            </tr>
                                        </template>
                                        <tr class="totat_tr">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                                            <td class="summ_text summ_value">{{ summProductsTypes(types) }}</td>
                                            <td></td>
                                        </tr>
                                        <tr class="totat_tr">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="summ_text summ_point" colspan="2">ПДВ</td>
                                            <td class="summ_text summ_value">{{ productsPdwTypes(types) }}</td>
                                            <td></td>
                                        </tr>
                                        <tr class="totat_tr">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                                            <td class="summ_text summ_value">{{ summProductsPdwTypes(types) }}</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                        <br>
                        <br>
                    </template>
                </template>
                <template v-if="summarize">
                    <table style="width:100%; z-index:1;border-collapse: collapse;" class="spec_table" border=1>
                        <thead>
                            <th class="total_key summ_text">#</th>
                            <th class="total_title summ_text">Найменування</th>
                            <th class="total_maker summ_text">Виробник</th>
                            <th class="total_count summ_text">Кількість</th>
                            <th class="total_od summ_text">Од. Вим.</th>
                            <th class="total_price center summ_text">Ціна, грн. без ПДВ</th>
                            <th class="total_summ2 center summ_text">Сума, грн. без ПДВ</th>
                            <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                        </thead>
                        <tbody>
                            <template v-for="(products, name) in specItemsSummarized" :key="`itemi_${name}`">
                                <tr>
                                    <td class="total_key"></td>
                                    <td class="total_title"><p class="title">{{ name }}</p></td>
                                    <td class="total_maker"></td>
                                    <td class="total_count"></td>
                                    <td class="total_od"></td>
                                    <td class="total_price"></td>
                                    <td class="total_summ2"></td>
                                    <td class="total_tech"></td>
                                </tr>

                                <tr v-for="(item, i) in products" :key="`item_${i}`">
                                    <td class="total_key">{{ i+1 }}</td>
                                    <td class="total_title">{{ item.description }}</td>
                                    <td class="total_maker">{{ item.maker }}</td>
                                    <td class="total_count">{{ item.count }}</td>
                                    <td class="total_od">шт.</td>
                                    <td class="total_price">{{ numberWithSpaces(item.price_nds/1.2) }}</td>
                                    <td class="total_summ2">{{ numberWithSpaces((item.price_nds/1.2) * item.count) }}</td>
                                    <td class="total_tech">
                                        <a :href="item.tech_char" target="_blank">
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                            </svg>
                                        </a>
                                    </td>
                                </tr>
                            </template>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                                <td class="summ_text summ_value">{{ summProductsTypes(specItemsSummarized) }}</td>
                                <td></td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">ПДВ</td>
                                <td class="summ_text summ_value">{{ productsPdwTypes(specItemsSummarized) }}</td>
                                <td></td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                                <td class="summ_text summ_value">{{ summProductsPdwTypes(specItemsSummarized) }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <br>
                </template>
            </div>
            <div class="modal_bottom">
                <a href="javascript:void(0)" v-on:click="() => {modal_total = false; summarize = false;}" class="modal_bottom_link">Повернутись до конфігуратора</a>
                <div class="modal_bottom__btns">
                    <a href="javascript:void(0)" v-on:click="summarize = !summarize" class="avr_summ_btn">
                        <span v-if="!summarize">Підсумувати</span>
                        <span v-if="summarize">Розділити</span>
                    </a>
                    <a href="javascript:void(0)" v-on:click="getExcel()" class="avr_excel_btn">Завантажити Excel</a>
                </div>
            </div>

            <div class="commercial_offer">
                <div class="commercial_offer_header" @click="dropCommercialOfferForm()">
                    <span class="commercial_offer_header_title">Замовити комерційну пропозицію</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{commercial_offer_drop_row: is_drop_commercial_offer}">
                        <g clip-path="url(#clip0_7979_151607)">
                            <path d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z" fill="#356EEF"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_7979_151607">
                            <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="commercial_offer_body" v-if="is_drop_commercial_offer">
                    <p class="commercial_offer_body_subtitle">Заповніть форму</p>
                    
                    <div class="flex-group customer_info">
                        <div class="flex_form">
                            <div class="flex-row">
                                <div class="form_grid">
                                    <div class="form_group">
                                        <label class="form_label">Організація</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.organization }" v-model="commercialOfferData.organization" type="text" placeholder="Назва" />
                                    </div>
                                    <div class="form_group">
                                        <label class="form_label">Контактна особа</label>
                                        <input class="form_input" v-model="commercialOfferData.name" type="text" placeholder="ПІБ" />
                                    </div>
                                </div>
                                <div class="form_grid">
                                    <div class="form_group">
                                        <label class="form_label">Номер телефону *</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.phone }" @input="acceptNumber" v-model="commercialOfferData.phone" type="text" placeholder="+380" />
                                        <p class="error_text" v-if="commercialOfferDataErrors.phone">Обов'язкове поле</p>
                                    </div>
                                    <div class="form_group">
                                        <label class="form_label">Електронна пошта *</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.email }" v-model="commercialOfferData.email" type="text" placeholder="Email" />
                                        <p class="error_text" v-if="commercialOfferDataErrors.email">Обов'язкове поле</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex_form">
                            <div class="form_group mr-9">
                                <label class="form_label">Комментар до замовлення</label>
                                <div class="textarea_container">
                                    <textarea v-model="commercialOfferData.comment" class="form_input form_textarea" maxlength="200" rows="5" placeholder="Коментар"></textarea>
                                    <span class="total_words">{{ commercialOfferData.comment ? commercialOfferData.comment.length : 0 }} / 200</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="commercial_offer_order" v-if="commercial_offer_sended">
                        <div class="block_row">
                            <p class="commercial_offer_order_title">Заявка №{{commercial_offer_id}} від</p>
                            <svg id="close_offer" @click="() => {commercial_offer_sended = false; is_disable_commercial_offer_btn = false}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"></path>
                            </svg>
                        </div>
                        <p class="commercial_offer_order_title">{{commercial_offer_created_at}}</p>
                        <p class="commercial_offer_order_text">Ваша запит на Комерційну пропозицію  зареєстрований та прийнятий, найближчим часом наш менеджер з Вами зв’яжеться. </p>
                    </div>

                    <a href="javascript:void(0)" v-if="!commercial_offer_sended" :disabled="is_disable_commercial_offer_btn" class="commercial_offer_order_btn" @click="commercialOrder()">
                        <template v-if="is_disable_commercial_offer_btn">
                            Зачекайте... <ProgressSpinner strokeWidth="5" style="width: 30px; height: 30px; margin: 0; margin-left: 30px;" />
                        </template>
                        <template v-else>Замовити</template>
                    </a>
                    <a href="javascript:void(0)" v-else class="commercial_offer_order_btn disabled">
                        Замовити
                    </a>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Tooltip from 'primevue/tooltip';


export default {
    directives: {
        Tooltip,
    },
    props: {
        text: {
            type: String,
            required: false,
        },
        file: {
            type: String,
            required: false,
        },
        images: {
            type: Array,
            required: false,
        }
    },

    components: {

    },
    layout: CommonLayout,

    data() {
        return {
            modal_info: false,
            modal_docs: false,
            modal_total: false,
            summarize: false,
            sliderIndex: 0,
            // images: [
            //     '/img/sho90/shcho901.png',
            //     '/img/sho90/shcho902.png',
            //     '/img/sho90/shcho903.png',
            //     '/img/sho90/shcho904.png',
            //     '/img/sho90/shcho905.png',
            //     '/img/sho90/shcho906.png',
            // ],
            loading: false,

            nominal_bus_currents: [],
            bus_materials: [],
            panel_depths: [],
            panel_implementations: [],
            socles: [],

            selected_nominal_bus_current: null,
            panel_count: null,
            selected_bus_material: null,
            selected_panel_depth: null,
            selected_panel_implementation: null,
            selected_socle: null,

            selected_nominal_bus_current_error: false,
            selected_bus_material_error: false,
            selected_panel_depth_error: false,
            selected_panel_implementation_error: false,
            panel_count_error: false,

            panels: [],
            files: [],


            panel_types: [],
            specItems: [],
            specItemsSummarized: [],

            openedPanel: [],

            default_auto_implementation: null,

            is_drop_commercial_offer: false,
            commercial_offer_sended: false,
            is_disable_commercial_offer_btn: false,
            commercial_offer_id: null,
            commercial_offer_created_at: null,
            commercialOfferData: {
                organization: null,
                name: null,
                phone: null,
                email: null,
                comment: null,
            },
            commercialOfferDataErrors: {
                phone: null,
                email: null,
            },
            panelsValidation: {},
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        getClass(type) {
            if (type && type === 'Ввідна') {
                return 'vvidna-bg'
            }
            if (type && type === 'Секційна') {
                return 'sekciyna-bg'
            }
            if (type && type === 'Лінійна') {
                return 'liniyna-bg'
            }
        },
        checkKey(i) {
            return Number.isInteger(parseInt(i))
        },
        openDocsModal() {
            if (this.validatePanels()) {
                this.modal_docs = true
            }
        },
        showSpec() {
            if (this.validatePanels()) {
                this.modal_total = true
            }
        },
        getExcel() {
            if (this.validatePanels()) {
                this.modal_total = false;

                axios.post(this.route('api.sho_90_get_excel'), {
                    items: this.summarize ? this.specItemsSummarized : this.specItems,
                    summarize: this.summarize,
                })
                .then((response) => {
                    this.summarize = false
                    var fileURL = response.data.data;
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', response.data.name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch((error) => {
                    this.summarize = false
                    console.log(error);
                    window.scroll(0, 0);
                })
            }
        },

        issetSectionPanel() {
            let validation = false
            if (this.panels.length) {
                this.panels.forEach((panel, panelIndex) => {
                    if (panel.panel_type === 'Секційна') {
                        validation = true
                    }
                })
            }

            return validation
        },

        validatePanelsDocModal() {
            let validated = true
            if (this.panels.length) {
                let counter = 0
                this.panels.forEach((panel, panelIndex) => {
                    if (panel.panel_type === 'Лінійна') {
                        counter++
                    }
                })
                if (counter === this.panels.length) {
                    validated = false
                }
            }

            return validated
        },

        validatePanels() {
            let validated = true

            let validationItems = {}

            if (this.panels.length) {
                this.panels.forEach((panel, panelIndex) => {
                    validationItems[panelIndex] = []

                    if (!panel.panel_type) {
                        validated = false
                        validationItems[panelIndex].push('panel_type')
                    }
                    if (!panel.panel_width) {
                        validated = false
                        validationItems[panelIndex].push('panel_width')
                    }
                    if (!panel.auto_switcher_current && panel.panel_type !== 'Лінійна') {
                        validated = false
                        validationItems[panelIndex].push('auto_switcher_current')
                    }
                    if (!panel.auto_implementation && panel.panel_type !== 'Лінійна') {
                        validated = false
                        validationItems[panelIndex].push('auto_implementation')
                    }
                    if (!panel.avr_panel && panel.panel_type !== 'Лінійна') {
                        validated = false
                        validationItems[panelIndex].push('avr_panel')
                    }
                    if (panel.panel_type === 'Лінійна') {
                        panel.multipart.forEach((multipartValue, multipartIndex) => {
                            if (multipartIndex < panel.disconnector_count) {
                                if (!multipartValue.disconnector_current) {
                                    validated = false
                                    validationItems[panelIndex].push('disconnector_current_' + multipartIndex)
                                }
                                if (!multipartValue.fuse_current) {
                                    validated = false
                                    validationItems[panelIndex].push('fuse_current_' + multipartIndex)
                                }
                                // if (!multipartValue.avr_panel) {
                                //     validated = false
                                //     validationItems[panelIndex].push('avr_panel_' + multipartIndex)
                                // } 
                            }
                        });
                    }

                    this.panelsValidation = validationItems
                });
            } else {
                validated = false
            }

            return validated
        },

        sliderPrew() {
            if (this.sliderIndex > 0) {
                this.sliderIndex--;

                this.$refs["wrapper"].scrollLeft = this.$refs["wrapper"].scrollLeft - 60
            }
        },
        sliderNext() {
            if (this.sliderIndex < this.images.length-1) {
                this.sliderIndex++;

                this.$refs["wrapper"].scrollLeft = this.$refs["wrapper"].scrollLeft + 60
            }
        },
        openPanel(i, k=null) {
            let key = i
            if (k) {
                key += '_' + k
            }

            if (this.openedPanel.includes(key)) {
                let index = this.openedPanel.indexOf(key);
                if (index !== -1) {
                    this.openedPanel.splice(index, 1);
                }
            } else {
                this.openedPanel.push(key)
            }
        },
        getData() {
            this.loading = true;
            axios.post(this.route('api.sho90_data'))
                .then((result) => {
                    this.nominal_bus_currents = result.data.nominal_bus_currents;
                    this.bus_materials = result.data.bus_materials;
                    this.panel_depths = result.data.panel_depths;
                    this.panel_implementations = result.data.panel_implementations;
                    this.socles = result.data.socles;
                    this.panel_types = result.data.panel_types;

                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    alert(error);
                    window.scroll(0, 0);
                })
        },
        
        addPanel(type = null) {
            if (this.validateForm()) {
                const excludedTypes = ['selected_bus_material', 'selected_panel_depth', 'selected_panel_implementation', 'selected_socle'];

                if (excludedTypes.includes(type) && this.panels.length) {
                    this.getSpecItems()
                } else {
                    this.panels = []

                    for (let i = 0; i < this.panel_count; i++) {
                        if (!this.panels[i]) {
                            this.panels.push({
                                panel_type: null,
                                panel_width: null,
                                auto_switcher_current: null,
                                auto_implementation: null,
                                disconnector_current: null,
                                disconnector_count: 4,
                                fuse_current: null,
                                avr_panel: null,
                                commercial_accounting: null,

                                panel_types: this.panel_types,
                                panel_widths: [],
                                auto_switcher_currents: [],
                                auto_implementations: [],
                                disconnector_currents: [],
                                fuse_currents: [],
                                avr_panels: [],
                                commercial_accountings: [],

                                multipart: [
                                    {
                                        disconnector_current: null,
                                        fuse_current: null,
                                        avr_panel: null,
                                        commercial_accounting: null,
                                        disconnector_currents: [],
                                        fuse_currents: [],
                                        avr_panels: [],
                                        commercial_accountings: [],
                                    },
                                    {
                                        disconnector_current: null,
                                        fuse_current: null,
                                        avr_panel: null,
                                        commercial_accounting: null,
                                        disconnector_currents: [],
                                        fuse_currents: [],
                                        avr_panels: [],
                                        commercial_accountings: [],
                                    },
                                    {
                                        disconnector_current: null,
                                        fuse_current: null,
                                        avr_panel: null,
                                        commercial_accounting: null,
                                        disconnector_currents: [],
                                        fuse_currents: [],
                                        avr_panels: [],
                                        commercial_accountings: [],
                                    },
                                    {
                                        disconnector_current: null,
                                        fuse_current: null,
                                        avr_panel: null,
                                        commercial_accounting: null,
                                        disconnector_currents: [],
                                        fuse_currents: [],
                                        avr_panels: [],
                                        commercial_accountings: [],
                                    },
                                    {
                                        disconnector_current: null,
                                        fuse_current: null,
                                        avr_panel: null,
                                        commercial_accounting: null,
                                        disconnector_currents: [],
                                        fuse_currents: [],
                                        avr_panels: [],
                                        commercial_accountings: [],
                                    },
                                    {
                                        disconnector_current: null,
                                        fuse_current: null,
                                        avr_panel: null,
                                        commercial_accounting: null,
                                        disconnector_currents: [],
                                        fuse_currents: [],
                                        avr_panels: [],
                                        commercial_accountings: [],
                                    },
                                ]
                            })
                        }
                    }
                }
            }
        },
        changeMultipart(i) {
            this.panels[i].multipart.forEach((value, index) => {
                this.panels[i].multipart[index].disconnector_current = null
                this.panels[i].multipart[index].fuse_current = null
                this.panels[i].multipart[index].avr_panel = null
                this.panels[i].multipart[index].commercial_accounting = null
                this.panels[i].multipart[index].disconnector_currents = []
                this.panels[i].multipart[index].fuse_currents = []
                this.panels[i].multipart[index].avr_panels = []
                this.panels[i].multipart[index].commercial_accountings = []
            });
        },
        validateForm() {
            this.selected_nominal_bus_current_error = false
            this.selected_bus_material_error = false
            this.selected_panel_depth_error = false
            this.selected_panel_implementation_error = false
            this.panel_count_error = false

            if (!this.selected_nominal_bus_current) {
                this.selected_nominal_bus_current_error = true
                return false
            }
            if (!this.selected_bus_material) {
                this.selected_bus_material_error = true
                return false
            }
            if (!this.panel_count) {
                this.panel_count_error = true
                return false
            }
            if (!this.selected_panel_depth) {
                this.selected_panel_depth_error = true
                return false
            }
            if (!this.selected_panel_implementation) {
                this.selected_panel_implementation_error = true
                return false
            }

            return true
        },
        getNextStep(index, key, data, k=null) {
            if (key === 'panel_widths') {
                for (let i = index+1; i < this.panel_count; i++) {
                    if (this.panels[i]) {
                        this.panels[i].panel_type = null
                        this.panels[i].panel_width = null
                        this.panels[i].auto_switcher_current = null
                        this.panels[i].auto_implementation = null
                        this.panels[i].disconnector_current = null
                        this.panels[i].disconnector_count = 4
                        this.panels[i].fuse_current = null
                        this.panels[i].avr_panel = null
                        this.panels[i].commercial_accounting = null

                        this.panels[i].panel_widths = []
                        this.panels[i].auto_switcher_currents = []
                        this.panels[i].auto_implementations = []
                        this.panels[i].disconnector_currents = []
                        this.panels[i].fuse_currents = []
                        this.panels[i].avr_panels = []
                        this.panels[i].commercial_accountings = []

                        this.panels[i].multipart = [
                            {
                                disconnector_current: null,
                                fuse_current: null,
                                avr_panel: null,
                                commercial_accounting: null,
                                disconnector_currents: [],
                                fuse_currents: [],
                                avr_panels: [],
                                commercial_accountings: [],
                            },
                            {
                                disconnector_current: null,
                                fuse_current: null,
                                avr_panel: null,
                                commercial_accounting: null,
                                disconnector_currents: [],
                                fuse_currents: [],
                                avr_panels: [],
                                commercial_accountings: [],
                            },
                            {
                                disconnector_current: null,
                                fuse_current: null,
                                avr_panel: null,
                                commercial_accounting: null,
                                disconnector_currents: [],
                                fuse_currents: [],
                                avr_panels: [],
                                commercial_accountings: [],
                            },
                            {
                                disconnector_current: null,
                                fuse_current: null,
                                avr_panel: null,
                                commercial_accounting: null,
                                disconnector_currents: [],
                                fuse_currents: [],
                                avr_panels: [],
                                commercial_accountings: [],
                            },
                            {
                                disconnector_current: null,
                                fuse_current: null,
                                avr_panel: null,
                                commercial_accounting: null,
                                disconnector_currents: [],
                                fuse_currents: [],
                                avr_panels: [],
                                commercial_accountings: [],
                            },
                            {
                                disconnector_current: null,
                                fuse_current: null,
                                avr_panel: null,
                                commercial_accounting: null,
                                disconnector_currents: [],
                                fuse_currents: [],
                                avr_panels: [],
                                commercial_accountings: [],
                            },
                        ]
                    }
                }
            }

            if (key === 'panel_widths') {
                if (data.panel_type === 'Лінійна') {
                    let totalCnt2 = 0
                    let totalCnt3 = 0
                    for (let i = 0; i < this.panel_count; i++) {
                        if (this.panels[i]) {
                            totalCnt2 += this.panels[i].panel_type === 'Секційна' ? 1 : 0
                            totalCnt3 += this.panels[i].panel_type === 'Ввідна' ? 1 : 0
                        }
                    }

                    if (index > 0 && this.panels[index-1].panel_type === 'Ввідна') {
                        if (this.panels[index+1]) {
                            if (totalCnt2 === 1) {
                                this.panels[index+1].panel_types = ['Лінійна']
                            } else {
                                if (index+2 === this.panels.length) {
                                    this.panels[index+1].panel_types = ['Лінійна']
                                } else {
                                    this.panels[index+1].panel_types = ['Секційна', 'Лінійна']
                                }
                            }
                        }
                    } else {
                        if (this.panels[index+1]) {
                            if (totalCnt3 === 2) {
                                this.panels[index+1].panel_types = ['Лінійна']
                            } else if (totalCnt3 === 0) {
                                this.panels[index+1].panel_types = ['Ввідна', 'Лінійна']
                            } else {
                                if (totalCnt2 === 0) {
                                    if (index+2 === this.panel_count) {
                                        this.panels[index+1].panel_types = ['Лінійна']
                                    } else {
                                        this.panels[index+1].panel_types = ['Лінійна', 'Секційна']
                                    }
                                } else {
                                    this.panels[index+1].panel_types = ['Ввідна', 'Лінійна']
                                }
                            }
                        }
                    }
                }
                if (data.panel_type === 'Секційна') {
                    let nextIndex = index + 1
                    for (let i = nextIndex; i < this.panel_count; i++) {
                        if (this.panels[i]) {
                            this.panels[i].panel_types = ['Ввідна', 'Лінійна']
                        }
                    }
                }
                if (data.panel_type === 'Ввідна') {
                    let totalCnt1 = 0
                    for (let i = 0; i < this.panel_count; i++) {
                        if (this.panels[i]) {
                            totalCnt1 += this.panels[i].panel_type === 'Ввідна' ? 1 : 0
                        }
                    }

                    if (totalCnt1 === 2) {
                        let nextIndex = index + 1
                        for (let i = nextIndex; i < this.panel_count; i++) {
                            if (this.panels[i]) {
                                this.panels[i].panel_types = ['Лінійна']
                            }
                        }
                    } else {
                        if (this.panels[index+1]) {
                            this.panels[index+1].panel_types = ['Лінійна', 'Секційна']
                        }
                    }
                    
                }
                // else {
                //     for (let i = 0; i < this.panel_count; i++) {
                //         if (this.panels[i]) {
                //             this.panels[i].panel_types = ['Ввідна', 'Лінійна', 'Секційна']
                //         }
                //     }
                // }
            }

            this.selected_nominal_bus_current_error = false
            this.selected_bus_material_error = false
            this.selected_panel_depth_error = false
            this.selected_panel_implementation_error = false

            if (!this.selected_nominal_bus_current) {
                this.selected_nominal_bus_current_error = true
                return false
            }
            if (!this.selected_bus_material) {
                this.selected_bus_material_error = true
                return false
            }
            if (!this.selected_panel_depth) {
                this.selected_panel_depth_error = true
                return false
            }
            if (!this.selected_panel_implementation) {
                this.selected_panel_implementation_error = true
                return false
            }

            if (key === 'panel_widths') {
                this.panels[index].panel_width = 600
                this.panels[index].auto_switcher_current = null
                this.panels[index].auto_implementation = null
                this.panels[index].disconnector_current = null
                this.panels[index].disconnector_count = 4
                this.panels[index].fuse_current = null
                this.panels[index].avr_panel = null
                this.panels[index].commercial_accounting = null
            }
            if (key === 'auto_switcher_currents') {
                this.panels[index].auto_switcher_current = null
                this.panels[index].auto_implementation = null
                this.panels[index].disconnector_current = null
                this.panels[index].disconnector_count = 4
                this.panels[index].fuse_current = null
                this.panels[index].avr_panel = null
                this.panels[index].commercial_accounting = null
            }
            if (key === 'auto_implementations') {
                this.panels[index].auto_implementation = null
                this.panels[index].disconnector_current = null
                this.panels[index].disconnector_count = 4
                this.panels[index].fuse_current = null
                this.panels[index].avr_panel = null
                this.panels[index].commercial_accounting = null
            }
            if (key === 'disconnector_currents') {
                this.panels[index].disconnector_current = null
                this.panels[index].disconnector_count = data.panel_width === 600 ? 4 : 6
                this.panels[index].fuse_current = null
                this.panels[index].avr_panel = null
                this.panels[index].commercial_accounting = null
            }
            if (key === 'fuse_currents') {
                this.panels[index].fuse_current = null
                this.panels[index].avr_panel = null
                this.panels[index].commercial_accounting = null
            }
            if (key === 'avr_panels') {
                this.panels[index].avr_panel = null
                this.panels[index].commercial_accounting = null
            }
            if (key === 'commercial_accountings') {
                this.panels[index].commercial_accounting = null
            }

            if (k >= 0 && this.panels[index].panel_type === 'Лінійна') {
                if (key === 'fuse_currents') {
                    this.panels[index].multipart[k].fuse_current = null
                    this.panels[index].multipart[k].avr_panel = null
                    this.panels[index].multipart[k].commercial_accounting = null
                }
                if (key === 'avr_panels') {
                    this.panels[index].multipart[k].avr_panel = null
                    this.panels[index].multipart[k].commercial_accounting = null
                }
                if (key === 'commercial_accountings') {
                    this.panels[index].multipart[k].commercial_accounting = null
                }
            }

            this.loading = true;
            axios.post(this.route('api.sho90_step'), {
                    key: key,
                    multipart_key: k,
                    data: data,
                    panel_type: this.panels[index].panel_type,
                    params: {
                        nominal_bus_current: this.selected_nominal_bus_current,
                        bus_material: this.selected_bus_material,
                        panel_depth: this.selected_panel_depth,
                        panel_implementation: this.selected_panel_implementation
                    },
                    panels: this.panels
                })
                .then((result) => {
                    if (this.panels[index]) {
                        this.panels[index][key] = result.data[key];

                        if (k >= 0 && this.panels[index].multipart[k] && this.panels[index].multipart[k][key]) {
                            this.panels[index].multipart[k][key] = result.data[key];
                        }
                    }

                    this.files = result.data.files

                    this.getSpecItems()

                    this.loading = false;

                    if (key === 'panel_widths') {
                        this.getNextStep(index, this.panels[index].panel_type === 'Лінійна' ? 'disconnector_currents' : 'auto_switcher_currents', this.panels[index])
                    }

                    if (k >= 0 && this.panels[index].panel_type === 'Лінійна') {
                        if (key === 'fuse_currents') {
                            if (this.panels[index].multipart[k].disconnector_current === '630' && this.panels[index].multipart[k].fuse_currents.includes(600)) {
                                this.panels[index].multipart[k].fuse_current = 600

                                this.getNextStep(index, 'avr_panels', this.panels[index], k)
                            } else {
                                if (this.panels[index].multipart[k].fuse_currents.includes( parseInt(this.panels[index].multipart[k].disconnector_current) )) {
                                    this.panels[index].multipart[k].fuse_current = this.panels[index].multipart[k].disconnector_current

                                    this.getNextStep(index, 'avr_panels', this.panels[index], k)
                                }
                            }
                        }
                        if (key === 'avr_panels') {
                            this.getNextStep(index, 'commercial_accountings', this.panels[index], k)
                        }
                    } else {
                        if (key === 'avr_panels') {
                            this.default_auto_implementation = this.panels[index].auto_implementation

                            for (let i = 0; i < this.panel_count; i++) {
                                if (this.panels[i] && this.panels[i].panel_type !== 'Лінійна' && this.panels[i].auto_switcher_current && this.panels[i].auto_implementation !== this.panels[index].auto_implementation) {
                                    this.panels[i].auto_implementation = this.panels[index].auto_implementation

                                    this.panels[i].avr_panel = null
                                    this.panels[i].commercial_accounting = null

                                    this.loading = true;
                                    axios.post(this.route('api.sho90_step'), {
                                            key: 'avr_panels',
                                            multipart_key: null,
                                            data: this.panels[i],
                                            panel_type: this.panels[i].panel_type,
                                            params: {
                                                nominal_bus_current: this.selected_nominal_bus_current,
                                                bus_material: this.selected_bus_material,
                                                panel_depth: this.selected_panel_depth,
                                                panel_implementation: this.selected_panel_implementation
                                            },
                                            panels: this.panels
                                        })
                                        .then((result) => {
                                            if (this.panels[i]) {
                                                this.panels[i].avr_panels = result.data[key];
                                            }

                                            this.files = result.data.filess

                                            this.getSpecItems()

                                            this.loading = false;
                                        }).catch((error) => {
                                            this.loading = false;
                                            console.log(error);
                                            window.scroll(0, 0);
                                        })
                                }
                            }
                        }
                    }

                }).catch((error) => {
                    this.loading = false;
                    console.log(error);
                    window.scroll(0, 0);
                })

            this.panelsValidation = {}
        },

        getSpecItems() {
            axios.post(this.route('api.sho90_spec_items'), {
                data: this.panels,
                selects: {
                    selected_nominal_bus_current: this.selected_nominal_bus_current,
                    selected_bus_material: this.selected_bus_material,
                    selected_panel_depth: this.selected_panel_depth,
                    selected_panel_implementation: this.selected_panel_implementation,
                    selected_socle: this.selected_socle,
                }
            })
                .then((result) => {
                    this.specItems = result.data.result
                    this.specItemsSummarized = result.data.summarized
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                })
        },


        numberWithSpaces(x) {
            x = parseFloat(x);
            x = x.toFixed(2);
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(",");
        },
        
        summProductsTypes(items) {
            let summ = 0;

            for (const [key, values] of Object.entries(items)) {
                values.forEach((item, index) => {
                    summ += (item.count * (item.price_nds/1.2));
                });
            }

            return this.numberWithSpaces(summ);
        },
        
        productsPdwTypes(items) {
            let summ = 0;
            let summPdv = 0;

            for (const [key, values] of Object.entries(items)) {
                values.forEach((item, index) => {
                    summ += (item.count * item.price_nds);
                    summPdv += (item.count * (item.price_nds/1.2));
                });
            }

            return this.numberWithSpaces(summ - summPdv);
        },
        
        summProductsPdwTypes(items) {
            let summ = 0;

            for (const [key, values] of Object.entries(items)) {
                values.forEach((item, index) => {
                    summ += (item.count * item.price_nds);
                });
            }

            return this.numberWithSpaces(summ);
        },


        dropCommercialOfferForm() {
            this.is_drop_commercial_offer = !this.is_drop_commercial_offer
        },
        acceptNumber() {
            var x = this.commercialOfferData.phone.replace(/\D/g, '').replace('380', '').replace('38', '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);

            this.commercialOfferData.phone = !x[2] && x[1] ? '+380' + x[1] : (x[1] ? '+38 (0' + x[1] + ') ' : '+380') + x[2] + (x[3] ? '-' + x[3] : '');
        },
        commercialOrder() {
            if (!this.commercialOfferData.phone) {
                this.commercialOfferDataErrors.phone = true;
                return false;
            } else {
                this.commercialOfferDataErrors.phone = false;
            }
            if (!this.commercialOfferData.email || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.commercialOfferData.email))) {
                this.commercialOfferDataErrors.email = true;
                return false;
            } else {
                this.commercialOfferDataErrors.email = false;
            }

            if (!this.is_disable_commercial_offer_btn) {
                this.is_disable_commercial_offer_btn = true;

                axios.post(this.route('make-offer'), {
                    type: 'Sho90Service',

                    items: this.summarize ? this.specItemsSummarized : this.specItems,
                    summarize: this.summarize,

                    organization: this.commercialOfferData.organization,
                    phone: this.commercialOfferData.phone,
                    name: this.commercialOfferData.name,
                    email: this.commercialOfferData.email,
                    comment: this.commercialOfferData.comment,
                    total_price: this.summProductsPdwTypes(this.specItemsSummarized),
                })
                .then((response) => {
                    this.commercial_offer_id = response.data.id;
                    this.commercial_offer_created_at = response.data.created_at;

                    this.commercial_offer_sended = true;

                    this.commercialOfferData.organization = null
                    this.commercialOfferData.name = null
                    this.commercialOfferData.phone = null
                    this.commercialOfferData.email = null
                    this.commercialOfferData.comment = null
                }).catch((error) => {
                    this.is_disable_commercial_offer_btn = false;
                    console.log(error);
                    window.scroll(0, 0);
                })
            }
        }
    }
};
</script>

<style scoped>
.container {
    padding: 80px 25px 0 20px;
}
#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.content_container {
    padding-top: 72px;
    display: flex;
    justify-content: space-between;
}
.service_header {
    display: flex;
    justify-content: space-between;
}
.service_title {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    color: #212529;
}
.info_btn {
    width: 251px;
    height: 48px;
    padding: 12px 30px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}
.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 466px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}

.modal_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    padding: 0;
    margin: 0;
}

#close_modal {
    cursor: pointer;
}

.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}
.input_container {
    display: flex;
    gap: 24px;
    margin-bottom: 24px;
}
.form_input_item {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.form_input_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}
.form_input_title b {
    color:#356EEF;
}
.form_select {
    padding: 10px 16px;
    width: 306px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}
select.not_selected {
  color: #6C757D;
}
select option.selectable {
  color: #000000;
}
.slider_main {
    position: relative;
    width: fit-content;
}
.slider_prev, .slider_next {
    position: absolute;
    cursor: pointer;
    padding: 20px;
    border-radius: 4px;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
}
.slider_prev {
    top: 50%;
    left: 0;
}
.slider_next {
    top: 50%;
    right: 0;
}
.slider_prev:hover, .slider_next:hover {
    background-color: #DEE2E699;
}
.slider_main img {
    height: 248px;
    width: auto;
}
.slider_indicators {
    display: flex;
    max-width: 30vw;
    overflow: auto;
    gap: 6px;
}
.slider_preview_img {
    height: 37px;
    width: auto;
    padding: 4px;
    cursor: pointer;
}
.slider_preview_img.active {
    border: 1.44px solid #C8E4FF;
    border-radius: 3.54px;
}
.main_table {
    width:100%;
    border-radius: 4px 4px 0px 0px;
}

.main_table, th, td {
  border: 1px solid #DEE2E6;
  border-collapse: collapse;
}

.main_table_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: var(--body-text-body-color, #212529);
    height: 60px;
    background: #E3F1FF;
    overflow-wrap: break-word;
    padding: 5px;
}

.main_table_row {
    height: 53px;
    vertical-align: top;
    padding: 0px;
    position: relative;
}
.svg_left svg {
    position: absolute;
    left: -4px;
    top: 0;
    bottom: 0;
    margin: auto 0;
}
.svg_lines {
    padding-top: 10px;
    position: absolute;
    right: -4px;
    z-index: 1;
}
@media only screen and (min-height: 2960px) and (max-width: 1848px) {
    .svg_left svg {
        left: -3.5px;
    }
}
.border_line {
    border-right: 1px solid;
}
.table_select {
    width: 100%;
    padding-left: 10px;
    padding-right: 30px;
    border: none;
    outline: none;
    text-indent: 1px;
    text-overflow: '';
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    cursor: pointer;
    min-width: 105px;
}
.main_table_row .table_select {
    height: 52px;
}
.main_table_container {
    margin-top: 70px;
}
.bottom_row {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-top: 40px;
}
.total_btns {
    display: flex;
    gap: 26px;
}
.view_spec_btn {
    width: 264px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.view_spec_btn.disabled, .btn-download.disabled {
    background: #DEE2E6;
    color: #6C757D;
}

.btn-download.disabled {
    border: none;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
}

.btn-download.disabled:hover {
    background: #DEE2E6;
    color: #6C757D;
}
.btn-download.disabled #download-icon {
    fill: #6C757D;
}
.btn-download.disabled:hover #download-icon {
    fill: #6C757D;
}

.download_spec {
    width: 323px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.download_spec.disabled {
    color: #6C757D;
}

.btn-download {
    display: flex;
    align-items: center;
    padding: 13px 30px;
    width: 241px;
    height: 48px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    cursor: pointer;
}
.btn-download:hover {
    background-color: #356EEF;
    color: #fff;
}
.btn-download:hover #download-icon {
    fill: #fff;
}
.btn-download svg{
    margin-right: 15px;
}
.table_num {
    display: block;
    padding-top: 15px;
}
.border-bottom {
    border-bottom: 1px solid #DEE2E6;
    border-radius: 0%;
}
.filelist {
    padding: 0px;
    margin: 0;
    margin-bottom: 24px;
    width: 100%;
    overflow: auto;
    max-height: 245px;
}

.filelist li {
    list-style: none;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 5px;
    width: 100%;
    padding: 13px;
    background: rgba(126, 170, 255, 0.2);
    border-radius: 4px;
}

.filelist li a {
    cursor: pointer;
}
.file_item {
    display: flex;
    gap: 17px;
    width: 100%;
    color: #000000;
}

.file_item_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 2px solid #2F80ED;
    padding-bottom: 5px;
}

.file_item_container .file_name {
    font-size: 12px;
    line-height: 18px;
}

.download_ico {
    display: flex;
    align-items: center;
}

.download_ico {
    display: flex;
    align-items: center;
}
.cat_name {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #000000;
    background: none!important;
    padding: 0!important;
}

.modal_total {
    width: 90%;
    top: 50%;
    max-width: 1296px;
    height: 80vh;
    overflow: auto;
}

.modal_total .modal_content{
    overflow: auto;
    height: 470px;
    font-size: 14px;
    line-height: 21px;
    margin: 0px;
}
.modal_total .title{
    margin: 0px;
    padding: 0px;
}

.modal_total table {
    table-layout: fixed;
    font-size: 14px;
    line-height: 21px;
}

.title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}

.total_key {
    width: 22px;
    padding: 0;
    height: 38px;
    padding-right: 22px;
    text-align: center;
}
.total_title {
    width: 140px;
    padding: 0;
    text-align: left;
    padding-right: 22px;
    height: 38px;
}
.total_maker {
    width: 62px;
    padding: 0;
    text-align: left;
    padding-right: 22px;
    height: 38px;
}
.total_count {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_od {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_price {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_summ2 {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_tech {
    width: 30px;
    text-align: center;
    height: 38px;
}
.center {
    text-align: center;
    height: 38px;
}
.totat_tr {
    height: 38px;
}

.summ_text {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.summ_text.summ_point {
    text-align: right;
    padding-right: 42px;
}

.modal_bottom {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    width: 100%;
}

.modal_bottom_link {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #356EEF;
    cursor: pointer;
}

.modal_bottom__btns {
    display: flex;
    align-items: center;
    gap: 30px;
}

.avr_summ_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 154px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.avr_excel_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 203px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.modal_total table th, .modal_total table td, .modal_total table {
    border: none;
}
.modal_total thead {
    border-bottom: 1.5px solid #356EEF;
}
.modal_total tr {
    border-bottom: 1px solid #C8E4FF;
}
.modal_total tr:hover {
    background-color: #F0F8FF;
}
.modal_total .modal_header {
    border-bottom: none;
}


@media (max-width: 1300px) {
    .content_container {
        flex-direction: column;
    }
    .form_input_item, .form_select {
        width: 100%;
    }
    .slider_container {
        display: flex;
        justify-content: center;
    }
}

.loading {
    filter: opacity(0.5);
}

@media (max-width: 960px) {
    .total_key {
        width: 30px;
    }
    .total_title {
        padding-top: 15px;
        padding-bottom: 15px;
        width: 280px;
    }
    .total_maker {
        width: 125px;
    }
    .total_count {
        width: 90px;
    }
    .total_od {
        width: 90px;
    }
    .total_price {
        width: 90px;
    }
    .total_tech {
        width: 90px;
    }
    .add_item_modal .btn_container {
        justify-content: start;
    }
}

@media (max-width: 920px) {
    .main_table_container {
        width: 100%;
        overflow: auto;
    }
    .modal_total .modal_bottom {
        flex-direction: column;
        gap: 20px;
    }
}

@media (max-width: 780px) {
    .container {
        padding: 50px 0 0 0;
    }
    .service_header {
        flex-direction: column;
    }
    .slider {
        display: none;
    }
    .input_container {
        flex-direction: column;
    }
    .content_container {
        padding-top: 40px;
    }
}

@media (max-width: 450px) {
    .modal_total {
        height: 655px;
        top: 350px;
    }
    .modal_total .modal_content {
        height: 355px;
    }
    .modal_total .modal_bottom__btns {
        flex-direction: column;
    }
    .modal_total .avr_summ_btn {
        width: 100%;
    }
    .modal_total .avr_excel_btn, .description_modal, .docs_modal {
        width: 100%;
    }
}

@media (max-width: 400px) {
    .modal_total {
        height: 666px;
    }
}

@media (max-width: 390px) {
    .modal, .description_modal, .docs_modal, .modal_total {
        width: 330px;
    }
}

@media only screen and (max-height: 740px) and (min-width: 1200px) {
    .modal_total {
        top: 360px;
    }
    .modal_total .modal_content {
        height: 370px;
    }
}

.commercial_offer_header {
    border-radius: 4px;
    background: rgba(200, 228, 255, 0.45);
    padding: 24px 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    cursor: pointer;
}
.commercial_offer_header_title {
    color: #1C1C1C;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
}
.commercial_offer_drop_row {
    rotate: 180deg;
}
.commercial_offer_body {
    padding: 0px 16px 24px 16px;
    background: rgba(200, 228, 255, 0.45);
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}
.flex-row, .flex-group {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.customer_info .form_input {
    max-width: 100%;
}
.flex_form {
    width: 100%;
}
.form_grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}
.form_group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    position: relative;
}
.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}
.form_input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    max-width: 200px;
    height: 100%;
}
.border-danger {
    border: 1px solid red;
    color: red;
}
.error_text {
    color: red;
    position: absolute;
    bottom: -24px;
}
.form_textarea {
    max-width: 100%;
    height: auto;
}
.textarea_container {
    position: relative;
}
.total_words {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: rgb(95,99,104);
    font-size: 14px;
}
.commercial_offer_body .form_textarea {
    resize: none;
    width: 100%;
}
.commercial_offer_order_btn {
    border-radius: 4px;
    background: #356EEF;
    width: 282px;
    height: 48px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-top: 24px;
}
.commercial_offer_order_btn.disabled {
    background: #CED4DA;
}
.block_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
#close_offer {
    cursor: pointer;
}
.commercial_offer_order_title {
    color: #212529;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    margin: 0px;
}
.commercial_offer_order {
    margin-top: 24px;
    border-radius: 4px;
    border-left: 4px solid #356EEF;
    background: #FFF;
    padding: 16px;
}
.commercial_offer_order_text {
    margin-top: 12px;
}
@media (max-width: 1200px) {
    .customer_info {
        flex-direction: column;
    }
    .form_input {
        width: 100%!important;
    }
}

.mobile_table {
    display: none;
}

@media (max-width: 600px) {
    .mobile_table {
        display: block;
    }
    .main_table_container {
        display: none;
    }
    .flex-row {
        flex-direction: column!important;;
    }
    .commercial_offer_order_btn {
        width: 100%;
    }
    .total_btns, .total_btns {
        flex-direction: column;
        width: 100%;
    }
    .view_spec_btn, .download_spec, .metal_constr_select, .bottom_row_block, .btn-download {
        width: 100%;
    }
    .btn-download {
        justify-content: center;
    }
    .metal_constr_select {
        padding-right: 0px;
    }
    .bottom_row {
        flex-direction: column;
        gap: 20px;
    }
}
@media (min-width: 1600px) {
    .modal_total {
        height: auto;
    }
}

.mobile_table {
    padding: 12px;
    border-radius: 4px;
    border: 1px solid #C8E4FF;
}

.mobile_table .dropdown_item_content {
    margin-top: 12px;
}

.mobile_table .dropdown_item_content_title {
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    margin: 0px;
}

.mobile_table .form_select {
    padding: 6px 8px;
    height: 34px;
}

.mobile_table .dropdown_item_content_container {
    margin-bottom: 12px;
}

.mobile_table .dropdown_item {
    margin-bottom: 4px;
}

.dropdown_item_title {
    width: 100%;
    height: 51px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    background: #C8E4FF;
    cursor: pointer;
}

.dropdown_item_title2 {
    width: 100%;
    height: 40px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    background: #F5F6F8;
    cursor: pointer;
}
svg.active {
    transform: rotate(180deg);
}
.spec_table {
    border-bottom: 1px solid #C8E4FF;
}
.vvidna-bg, .vvidna-bg td, .vvidna-bg select {
    background-color: #ffff;
}
.sekciyna-bg, .sekciyna-bg td, .sekciyna-bg select {
    background-color: #F9FAFD;
}
.liniyna-bg, .liniyna-bg td, .liniyna-bg select {
    background-color: #F2F9FE;
}
</style>
